import { render, staticRenderFns } from "./OrganizationDetail.vue?vue&type=template&id=f1eacd9a&"
import script from "./OrganizationDetail.vue?vue&type=script&lang=js&"
export * from "./OrganizationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports